export default "__VITE_ASSET__B$hJ0M9S__"